'use client';

import { setClientTranslationCatalog } from '@/lib/i18n/client';

export function ClientTranslationCatalog({
  locale,
  messages,
}: {
  locale: string;
  messages: Record<string, unknown>;
}) {
  setClientTranslationCatalog(locale, messages);
  return null;
}
